module.exports = __webpack_public_path__ + "static/media/lab_chalkboard_overlay.4a6e4ef3.svg";